import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import { Brand } from "./Brand";
import { TopographicLines } from "./TopographicLines";

export function FinalCta() {
  const { messages } = useI18n();

  return (
    <section className="final-cta" aria-labelledby="final-cta-title">
      <TopographicLines className="final-cta__contours" />
      <span className="final-cta__sun" aria-hidden="true" />
      <div className="shell final-cta__inner">
        <div>
          <h2 id="final-cta-title">{messages.finalCta.title}</h2>
          <p>{messages.finalCta.body}</p>
        </div>
        <div className="final-cta__actions">
          <Link className="button button--light" to="/#interest">
            {messages.finalCta.join}
            <ArrowRight className="directional-icon" size={18} aria-hidden="true" />
          </Link>
          <Link className="text-link text-link--inverse" to="/?trade=1#interest">
            {messages.finalCta.trade}
          </Link>
        </div>
      </div>
    </section>
  );
}

export function Footer() {
  const { messages } = useI18n();

  return (
    <footer className="site-footer">
      <div className="shell site-footer__inner">
        <Brand />
        <nav aria-label={messages.footer.navigationLabel}>
          <Link to="/research">{messages.footer.research}</Link>
          <Link to="/journal">{messages.footer.journal}</Link>
          <Link to="/privacy">{messages.footer.privacy}</Link>
          <a href="mailto:hello@tunetailor.org">{messages.footer.contact}</a>
        </nav>
        <div className="site-footer__meta">
          <p>{messages.footer.disclosure}</p>
          <p>
            {messages.footer.location} ·{" "}
            <a href="mailto:hello@tunetailor.org">
              <bdi dir="ltr">hello@tunetailor.org</bdi>
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
